import * as pinia from 'pinia';

const useIOTDevicesStore = pinia.defineStore('IOTDevicesStore', {
  state: () => ({
    devices: {
      smartglasses: {
        id: 'smartglasses',
        label: 'Smart glasses',
        connected: false,
        disconnecting: false,
        streamEnabled: true,
        loading: false,
        dropdownOpen: false,
        qrModalOpen: false,
        action: {
          icon: 'ViceGlasses',
          label: 'Connect',
          method: 'openSmartGlassesModal',
        },
      },
      smartphone: {
        id: 'smartphone',
        label: 'Smartphone',
        connected: false,
        disconnecting: false,
        streamEnabled: true,
        loading: false,
        dropdownOpen: false,
        qrModalOpen: false,
        action: {
          icon: 'ViceSmartphone',
          label: 'Connect',
          method: 'openSmartphoneModal',
        },
      },
      stethoscope: {
        id: 'stethoscope',
        label: 'Stethoscope',
        connected: false,
        streamEnabled: true,
        loading: false,
        dropdownOpen: false,
        qrModalOpen: false,
        action: {
          icon: 'ViceStethoscope',
          label: 'Connect',
          method: 'openStethoscopeModal',
        },
      },
    },
    iotSockets: {
      smartglasses: null,
      stethoscope: null,
      smartphone: null,
    },
  }),

  getters: {
    connected: (state) => _.filter(state.devices, (device) => device.connected),
    disconnected: (state) => _.filter(state.devices, (device) => !device.connected),
    streaming: (state) =>
      _.filter(state.devices, (device) => device.connected && device.streamEnabled),
  },

  actions: {
    openSmartGlassesModal() {
      this.devices.smartglasses.qrModalOpen = true;
    },
    openSmartphoneModal() {
      this.devices.smartphone.qrModalOpen = true;
    },
    closeSmartGlassesModal() {
      this.devices.smartglasses.qrModalOpen = false;
    },
    closeSmartphoneModal() {
      this.devices.smartphone.qrModalOpen = false;
    },
    openStethoscopeModal() {
      this.devices.stethoscope.qrModalOpen = true;
    },
    closeStethoscopeModal() {
      this.devices.stethoscope.qrModalOpen = false;
    },
    toggleDeviceStreamLoading(deviceId) {
      this.devices[deviceId].loading = !this.devices[deviceId].loading;
    },
    toggleDeviceStream(deviceId) {
      this.devices[deviceId].streamEnabled = !this.devices[deviceId].streamEnabled;
      this.toggleDeviceStreamLoading(deviceId);
    },
    closeDeviceStreamDropdown(deviceId) {
      this.devices[deviceId].dropdownOpen = false;
    },
    openDeviceStreamDropdown(deviceId) {
      this.devices[deviceId].dropdownOpen = true;
    },
  },
});
export default useIOTDevicesStore;
